import DynamicCategoryCarousel from '../scripts/sections/DynamicCategoryCarousel';
import DynamicCollectionList from '../scripts/sections/DynamicCollectionList';
import DynamicFeaturedFeed from '../scripts/sections/DynamicFeaturedFeed';
import DynamicHero from '../scripts/sections/DynamicHero';
import DynamicMediaWProducts from '../scripts/sections/DynamicMediaWProducts';
import DynamicProductFeed from '../scripts/sections/DynamicProductFeed';
import DynamicReviews from '../scripts/sections/DynamicReviews';
import DynamicSlideshow from '../scripts/sections/DynamicSlideshow';

// Sections
import MainAnnouncementBar from '../scripts/sections/MainAnnouncementBar';
import MainCart from '../scripts/sections/MainCart';
import MainCollection from '../scripts/sections/MainCollection';
import MainCollectionBanner from '../scripts/sections/MainCollectionBanner';
import MainContact from '../scripts/sections/MainContact';
import MainFaq from '../scripts/sections/MainFaq';
import MainHeader from '../scripts/sections/MainHeader';
import MainMinicart from '../scripts/sections/MainMinicart';
import MainProduct from '../scripts/sections/MainProduct';
import Sections from '../scripts/helpers/SectionManager';

import initAOS from '../scripts/global/initAos';
import initBuyButtons from '../scripts/global/initBuyButtons';
import initModals from '../scripts/global/initModals';
import initVideos from '../scripts/global/initVideos';

// Init global sections
const sections = new Sections();
sections.register('main-product', section => new MainProduct(section));
sections.register(
  'main-collection-grid',
  section => new MainCollection(section),
);
sections.register(
  'main-collection-banner',
  section => new MainCollectionBanner(section),
);
sections.register('main-header', section => new MainHeader(section));
sections.register(
  'main-announcement-bar',
  section => new MainAnnouncementBar(section),
);
sections.register('main-minicart', section => new MainMinicart(section));
sections.register('main-cart', section => new MainCart(section));
sections.register('main-faq', section => new MainFaq(section));
sections.register('main-contact', section => new MainContact(section));
sections.register('main-search', section => new MainCollection(section));

sections.register(
  'dynamic-collection-list',
  section => new DynamicCollectionList(section),
  { lazy: true },
);
sections.register(
  'dynamic-category-carousel',
  section => new DynamicCategoryCarousel(section),
  { lazy: true },
);
sections.register(
  'dynamic-product-feed',
  section => new DynamicProductFeed(section),
  { lazy: true },
);
sections.register(
  'dynamic-featured-feed',
  section => new DynamicFeaturedFeed(section),
  { lazy: true },
);
sections.register(
  'dynamic-media-w-products',
  section => new DynamicMediaWProducts(section),
  { lazy: true },
);

sections.register('dynamic-hero', section => new DynamicHero(section), {
  lazy: true,
});
sections.register(
  'dynamic-slideshow',
  section => new DynamicSlideshow(section),
  { lazy: true },
);
sections.register('dynamic-reviews', section => new DynamicReviews(section), {
  lazy: true,
});

initAOS();
initVideos();
initModals();
initBuyButtons();
